export default {
      path: '/lvy-active-rule-2019911',
      component: () => import('./LVYActiveRule_2019911'),
      meta: {
        title: '活动规则',
        designWidth:750,
        expireIn: '',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
